import { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, DatePicker, Select, Typography, Divider, Checkbox, notification } from "antd";
import { PlusOutlined, MinusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { dropdownService, quotationService } from "../../../services";
import dayjs from "dayjs";
import MaterialLikeSelect from "../../../components/MaterialLikeSelect";
import MaterialLikeDatePicker from "../../../components/MaterialLikeDatePicker";
import MaterialLikeInput from "../../../components/MaterialLikeInput";
import { changeDocumentTitle } from "../../../utils/title";
// import dayjs from "dayjs";

function RateSendingForm() {
    const { id } = useParams();
    const isEditMode = id !== undefined;
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [customers, setCustomers] = useState([]);
    const [containerSizes, setContainerSizes] = useState([])
    const [shippingLines, setShippingLines] = useState([])
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [initialIsSended, setInitialIsSended] = useState(false);

    const onFinish = async (values) => {
        console.log("Form Values:", values);
        const data = {
            ...values,
            date: values.date ? values.date.format("YYYY-MM-DD") : null,
            valid_till: values.valid_till ? values.valid_till.format("YYYY-MM-DD") : null,
            is_sended: values.is_sended ? 1 : 0
        }
        setLoading(true)
        const response = isEditMode ? await quotationService.updateRateSending(id, data) : await quotationService.storeRateSending(data)
        setLoading(false)
        if (response?.success ?? false) {
            notification.success({ message: isEditMode ? "Rate Updated" : "Rate Stored Successfully" })
            navigate('/operations/rate-sending')
        }
    };

    const getCustomers = async () => {
        setLoading2(true)
        const { success, data } = await dropdownService.fetchCustomers();
        setLoading2(false)
        if (success) {
            setCustomers(data);
        }
    };
    const getContainerSizes = async () => {
        const { success, data } = await dropdownService.fetchContainerSizes();
        if (success) {
            setContainerSizes(data);
        }
    };
    const getShippingLines = async () => {
        const { success, data } = await dropdownService.fetchShippingLines();
        if (success) {
            setShippingLines(data);
        }
    };

    const initialize = async () => {
        const { success, data } = await quotationService.viewRate(id);
        if (success) {
            form.setFieldsValue({
                ...data,
                date: dayjs(data.date),
                valid_till: dayjs(data.valid_till),
                customer_ids: data.customers.map(r => r.id),
                // customer_ids: [...new Set(data.recipients.map(r => r.customer_id))],
                ocean_freight_loading: data.ocean_freights.map(f => ({
                    pol: f.pol,
                    pod: f.pod,
                    shipping_line_id: f.shipping_line_id,
                    container_size_id: f.container_size_id,
                    cars: f.cars,
                    rate: f.rate,
                })),
                storage_policy: data.storage_policies.map(s => ({
                    yard: s.yard,
                    free_days: s.free_days,
                    rate: s.rate,
                    remarks: s.remarks,
                })),
            });
            setInitialIsSended(Boolean(data.is_sended));

        }
    }

    useEffect(() => {
        changeDocumentTitle(isEditMode ? " Edit Rate" : " Add Rate");
        if (isEditMode) {
            initialize();
        }
        getCustomers();
        getContainerSizes();
        getShippingLines();
    }, []);

    return (
        <div
            style={{
                padding: "0 14px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
            }}
        >
            <Row
                gutter={26}
                style={{
                    backgroundColor: "#FBFBFB",
                    marginBottom: 15,
                    padding: "10px",
                    borderRadius: "4px",
                    borderBottom: "1px solid #E8E8E9",
                }}
            >
                <Col span={12}>
                    <h1 style={{ fontWeight: "bold" }}>
                        {isEditMode ? "Edit Rate" : "Add Rate"}
                    </h1>
                </Col>
            </Row>

            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={{
                    ocean_freight_loading: [{}],
                    storage_policy: [{}],
                    remarks: `Additional charges $400 apply for 45FT bookings.
15 days free at facilities there after $15/day/car from the day of receiving in and out charges will be $100 subject to storage charges.`
                }}
            >
                <Row gutter={24}>
                    {/* Multiple Customers */}
                    <Col span={12}>
                        <Form.Item
                            name="customer_ids"
                            rules={[{ required: true, message: "Please select customers!" }]}
                        >
                            <MaterialLikeSelect
                                label="Customers"
                                required
                                value={form.getFieldValue("customer_ids")}
                                onChange={(value) => form.setFieldValue('customer_ids', value)}
                                options={customers.map((cust) => ({
                                    id: cust.id,
                                    value: cust.id,
                                    label: cust.name,
                                }))}
                                multiple />
                        </Form.Item>
                    </Col>

                    {/* Date */}
                    <Col span={6}>
                        <Form.Item
                            name="date"
                            rules={[{ required: true, message: "Please select date!" }]}
                        >
                            <MaterialLikeDatePicker
                                label="Date"
                                required
                                value={form.getFieldValue("date")}
                                onChange={(date) => form.setFieldValue("date", date)}
                            />
                        </Form.Item>
                    </Col>

                    {/* Valid Till */}
                    <Col span={6}>
                        <Form.Item
                            name="valid_till"
                            rules={[{ required: true, message: "Please select valid till!" }]}
                        >
                            <MaterialLikeDatePicker
                                label="Valid Till"
                                required
                                value={form.getFieldValue("valid_till")}
                                onChange={(date) => form.setFieldValue("valid_till", date)}
                            />
                        </Form.Item>
                    </Col>

                </Row>

                {/* Ocean Freight Table */}
                <Divider orientation="center" style={{ borderColor: "#B83D3D" }}>Ocean Freight & Loading</Divider>
                <Col span={24} className="px-3">
                    <Form.List name="ocean_freight_loading" >
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, ...restField }) => (
                                    <Row gutter={16} key={key} align="middle">
                                        <Col span={4}>
                                            <Form.Item {...restField} name={[name, "pol"]}>
                                                <MaterialLikeInput
                                                    label="POL"
                                                    value={form.getFieldValue(["ocean_freight_loading", name, "pol"])}
                                                    onChange={(e) =>
                                                        form.setFieldValue(["ocean_freight_loading", name, "pol"], e.target.value)
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={4}>
                                            <Form.Item {...restField} name={[name, "pod"]}>
                                                <MaterialLikeInput
                                                    label="POD"
                                                    value={form.getFieldValue(["ocean_freight_loading", name, "pod"])}
                                                    onChange={(e) =>
                                                        form.setFieldValue(["ocean_freight_loading", name, "pod"], e.target.value)
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={4}>
                                            <Form.Item {...restField} name={[name, "shipping_line_id"]} >
                                                <MaterialLikeSelect
                                                    label="Line"
                                                    required
                                                    value={form.getFieldValue(["ocean_freight_loading", name, "shipping_line_id"])}
                                                    onChange={(e) => form.setFieldValue(["ocean_freight_loading", name, "shipping_line_id"], e.target.value)}
                                                    options={shippingLines.map((line) => ({
                                                        id: line.id,
                                                        value: line.id,
                                                        label: line.name,
                                                    }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={3}>
                                            <Form.Item {...restField} name={[name, "container_size_id"]}>
                                                <MaterialLikeSelect
                                                    label="Size"
                                                    required
                                                    value={form.getFieldValue(["ocean_freight_loading", name, "container_size_id"])}
                                                    onChange={(e) => form.setFieldValue(["ocean_freight_loading", name, "container_size_id"], e.target.value)}
                                                    options={containerSizes.map((size) => ({
                                                        id: size.id,
                                                        value: size.id,
                                                        label: size.name,
                                                    }))}
                                                />

                                            </Form.Item>
                                        </Col>
                                        <Col span={3}>
                                            <Form.Item {...restField} name={[name, "cars"]}>
                                                <MaterialLikeInput
                                                    label="Cars"
                                                    value={form.getFieldValue(["ocean_freight_loading", name, "cars"])}
                                                    onChange={(e) =>
                                                        form.setFieldValue(["ocean_freight_loading", name, "cars"], e.target.value)
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={3}>
                                            <Form.Item {...restField} name={[name, "rate"]} >
                                                <MaterialLikeInput
                                                    label="Rate"
                                                    value={form.getFieldValue(["ocean_freight_loading", name, "rate"])}
                                                    onChange={(e) =>
                                                        form.setFieldValue(["ocean_freight_loading", name, "rate"], e.target.value)
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        {fields.length > 1 && <Col span={1} >
                                            <Button icon={<DeleteOutlined />} className="mb-10" size="small" onClick={() => remove(name)} type="primary" />
                                        </Col>}
                                    </Row>
                                ))}
                                <Col span={24} className="flex justify-center items-center">
                                    <Form.Item className="w-12">
                                        <Button type="primary" onClick={() => add()} block icon={<PlusOutlined />} />
                                    </Form.Item>
                                </Col>
                            </>
                        )}
                    </Form.List>
                </Col>

                {/* Storage Policy Table */}
                <Divider orientation="center" style={{ borderColor: "#B83D3D" }}>Storage Policy</Divider>
                <Col className="px-3" span={24}>
                    <Form.List name="storage_policy">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, ...restField }) => (
                                    <Row gutter={16} key={key} align="middle">
                                        <Col span={5}>
                                            <Form.Item {...restField} name={[name, "yard"]}>
                                                <MaterialLikeInput
                                                    label="Yard"
                                                    value={form.getFieldValue(["storage_policy", name, "yard"])}
                                                    onChange={(e) =>
                                                        form.setFieldValue(["storage_policy", name, "yard"], e.target.value)
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={4}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "free_days"]}
                                            >
                                                <MaterialLikeInput
                                                    label="Free Days"
                                                    value={form.getFieldValue(["storage_policy", name, "free_days"])}
                                                    onChange={(e) =>
                                                        form.setFieldValue(["storage_policy", name, "free_days"], e.target.value)
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={4}>
                                            <Form.Item {...restField} name={[name, "rate"]}>
                                                <MaterialLikeInput
                                                    label="Rate"
                                                    value={form.getFieldValue(["storage_policy", name, "rate"])}
                                                    onChange={(e) =>
                                                        form.setFieldValue(["storage_policy", name, "rate"], e.target.value)
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "remarks"]}
                                            >
                                                <MaterialLikeInput
                                                    label="Remarks"
                                                    value={form.getFieldValue(["storage_policy", name, "remarks"])}
                                                    onChange={(e) =>
                                                        form.setFieldValue(["storage_policy", name, "remarks"], e.target.value)
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        {fields.length > 1 && <Col span={1}>
                                            <Button icon={<DeleteOutlined />} className="mb-10" size="small" onClick={() => remove(name)} type="primary" />
                                        </Col>}
                                    </Row>
                                ))}
                                <Col span={24} className="flex justify-center items-center">
                                    <Form.Item className="w-12">
                                        <Button type="primary" onClick={() => add()} block icon={<PlusOutlined />} />
                                    </Form.Item>
                                </Col>
                            </>
                        )}
                    </Form.List>
                </Col>
                <Col span={12} className="px-3">
                    <Form.Item
                        label="Remarks"
                        name="remarks"
                    // rules={[{ required: true, message: "Please select valid till!" }]}
                    >
                        <Input.TextArea rows={5} />
                    </Form.Item>
                </Col>
                <Divider />
                {/* Send to Customers Checkbox */}
                <Row className="px-3">
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Form.Item name="is_sended" valuePropName="checked">
                            <Checkbox><span className="text-xl">Send to customers</span></Checkbox>
                        </Form.Item>
                    </Col>
                </Row>

                <Row >
                    <Col span={24} style={{ textAlign: "right", paddingBottom: 20 }}>
                        <Button
                            type="primary"
                            style={{ width: "20%" }}
                            loading={loading}
                            onClick={() => form.submit()}
                            disabled={initialIsSended && isEditMode}
                        >
                            {isEditMode ? "Update Rate" : "Add Rate"}
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}

export default RateSendingForm;
